import { CLOUD_DEV_HOSTS, CLOUD_PROD_HOSTS, isCloudDevDeploy } from '../../../../config/cloud-deploy-hosts'

/**
 * Runtime URL config derived from current host.
 * Same bundle works on gmail.serviceflow-pro.com (production) and localhost (dev)
 * without build-time env vars.
 */
function getHost(): string {
  return typeof window !== 'undefined' ? window.location.hostname : ''
}

function isProductionHost(): boolean {
  const host = getHost()
  return host === 'gmail.serviceflow-pro.com' || host.endsWith('.serviceflow-pro.com')
}

function cloudHosts() {
  if (isCloudDevDeploy() || getHost().startsWith('dev-')) return CLOUD_DEV_HOSTS
  return CLOUD_PROD_HOSTS
}

export function getApiBaseUrl(): string {
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL
  if (isProductionHost()) return `${cloudHosts().api}/api`
  if (getHost() === 'localhost' || getHost() === '127.0.0.1') return 'http://localhost:3001/api'
  return `${CLOUD_PROD_HOSTS.api}/api`
}

export function getWebPortalUrl(): string {
  if (import.meta.env.VITE_WEB_PORTAL_URL) return import.meta.env.VITE_WEB_PORTAL_URL
  if (isProductionHost()) return cloudHosts().webApp
  return 'http://localhost:3000'
}
